import React from 'react';
import './Tile.css';

export function Tile({ icon, buttonText, onClick, disabled }) {
  return (
    <div className="card card-large">
      <div className="card-large-content tile-content">
        <div className="tile-icon" aria-hidden="true">{icon}</div>
        <div className="action-buttons">
          <div className="device-actions tile-actions">
            <button
              type="button"
              onClick={onClick}
              aria-label={buttonText}
              title={buttonText}
              disabled={disabled}
              aria-disabled={disabled}
            >
              {buttonText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
